export default {
  validation: {
    required: '為必填項目',
    kana_format: '',
    email_format: '請輸入 @.lower:validation.variables.email',
    date_format: '請輸入 @.lower:validation.variables.date',
    number_format: '請輸入 @.lower:validation.variables.number',
    halfwidth_number_format: '請輸入半形數字。',
    alphanumeric_format: '請輸入 @.lower:validation.variables.alphanumeric',
    postal_number_no_hyphen: '請輸入 @.lower:validation.variables.postal_number',
    postal_number_format: '郵寄區號請以無連字號指定',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: '請輸入 6文字以上',
    min_length: '請輸入 {length} 文字以上',
    max_length: '請輸入 {length} 文字以內',
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: '請輸入 {digit} 位數以內。',
    max_digit_with_item: '{item} 請輸入 {digit} 位數以內',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: '不可空白或僅輸入換行',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID／電子郵件地址',
      email: '電子郵件地址',
      password: '密碼',
      kana: '',
      date: '日期（例：31/01/2023）',
      number: '數字',
      alphanumeric: '半形英數字',
      postal_number: '郵遞區號',
    },
  },
}
